// extracted by mini-css-extract-plugin
module.exports = {"modal":"q_Z","modal__bg":"q_0","modal__close":"q_1","modal__header":"q_2","modal__header__close":"q_3","modal__content":"q_4"};